var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-video"},[_c('div',{staticClass:"mv__inner",attrs:{"data-youtube-id":_vm.videoId}},[_c('YoutubePlayer',{attrs:{"video-id":_vm.videoId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }